/* unplugin-vue-components disabled */import { render } from "./yilou.vue?vue&type=template&id=5abd98fa&scoped=true"
import script from "./yilou.vue?vue&type=script&lang=js"
export * from "./yilou.vue?vue&type=script&lang=js"

import "./yilou.vue?vue&type=style&index=0&id=5abd98fa&scoped=true&lang=css"

import exportComponent from "/Users/admin/Desktop/project/klb/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5abd98fa"]])

export default __exports__